import React from 'react'
import ReactExport from 'react-export-excel-xlsx-fix'
import { DownloadSimple } from '@phosphor-icons/react'
import moment from 'moment'

interface Props {
  selectedReport: string
  exportData: Array<object>
  startDate?: Date
  endDate?: Date
}

const LEGEND_ITEMS: { color: string; label: string }[] = [
  { color: '#F9F9F9', label: 'Past' },
  { color: '#72C02C', label: '0-2 months' },
  { color: '#E9C46A', label: '3-6 months' },
  { color: '#717182', label: '+6 months' },
]

const ReportTableTitleBar = ({ selectedReport, exportData, startDate, endDate }: Props) => {
  const reportFilename =
    selectedReport === 'Time Off' && startDate && endDate
      ? `Time Off Report - ${moment(startDate).format('MMM DD, YYYY')} - ${moment(endDate).format('MMM DD, YYYY')}`
      : `${selectedReport}-${moment().format('MM-DD-YYYY')}`
  // Excel sheet names are capped at 31 characters, unlike the file name above.
  const sheetName = (selectedReport === 'Time Off' ? 'Time Off Report' : selectedReport).slice(0, 31)
  return (
    <div className="reports-results-header">
      <h3 className="reports-card__title">{`${selectedReport} Report`}</h3>
      <div className="reports-card__header-actions">
        {selectedReport === "Time Off" &&
          <div className="reports-legend">
            {LEGEND_ITEMS.map(item => (
              <div key={item.label} className="reports-legend__item">
                <span className="reports-legend__swatch" style={{ background: item.color }} />
                {item.label}
              </div>
            ))}
          </div>
        }
        <ReactExport.ExcelFile
          filename={reportFilename}
          element={
            <button type="button" className="reports-download">
              <DownloadSimple size={16} weight="regular" />
              Download
            </button>
          }
        >
          <ReactExport.ExcelSheet
            dataSet={exportData}
            name={sheetName}
          />
        </ReactExport.ExcelFile>
      </div>
    </div>
  )
}

export default ReportTableTitleBar
